import { FlexiButton } from "appworks/graphics/elements/flexi-button";
import { Sprite } from "appworks/graphics/pixi/sprite";
import { Services } from "appworks/services/services";
import { AutoStartControl } from "appworks/ui/controls/standard/button/auto-start-control";
import { Tween } from "appworks/utils/tween";
import TWEEN = require("appworks/utils/tween");
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsAutoplayStartButtonControl extends AutoStartControl {
    protected flashTween: Tween;

    constructor(button: FlexiButton, protected lossLimitFlash: Sprite) {
        super(button);
        lossLimitFlash.alpha = 0;
    }

    public destroy(): void {
        super.destroy();
        TWEEN.remove(this.flashTween);
    }

    protected checkEnabled(): boolean {
        const autoplay = slotModel.read().autoplay;
        const numberOfAutoplaysSelected = autoplay.autoplays.currentValue > 0;
        return numberOfAutoplaysSelected;
    }

    protected onClick(): void {
        let { autoplay } = slotModel.read();

        const lossLimitPicked: boolean = this.lossLimitAmountHasBeenPicked();
        const lossLimitRequired: boolean = this.lossLimitAmountRequired();
        const lossLimitIsValid: boolean = this.lossLimitAmountIsValid();
        const lossLimitCheck: boolean = 
            (lossLimitPicked && lossLimitIsValid) || 
            (!lossLimitRequired && !lossLimitPicked);

        if (lossLimitCheck) {
            if (autoplay.autoplays.currentValue === 0) {
                autoplay.autoplays.currentValue = autoplay.autoplays.defaultValue;
            }

            // super.onClick updates the autoplay model, we have to read the model in again to avoid overwriting its changes.
            super.onClick();
            autoplay = slotModel.read().autoplay;
        } else {
            this.flashLossLimit();
        }

        slotModel.write({ autoplay });
    }

    protected flashLossLimit(): void {
        if (this.flashTween) {
            this.flashTween.stop();
            this.lossLimitFlash.alpha = 0;
        }
        this.flashTween = new Tween(this.lossLimitFlash)
            .to({ alpha: 1 }, 100)
            .yoyo(true)
            .repeat(9)
            .start();
    }

    protected lossLimitAmountIsValid(): boolean {
        const { lossLimit } = slotModel.read().autoplay;        
        const totalStake: number = Services.get(SlotBetService).getTotalStake();
        return lossLimit.currentValue >= totalStake;
    }

    protected lossLimitAmountHasBeenPicked(): boolean {
        const { lossLimit } = slotModel.read().autoplay;
        return lossLimit.currentValue > 0;
    }

    protected lossLimitAmountRequired(): boolean {
        const { lossLimit, lossLimitRequired } = slotModel.read().autoplay;
        return lossLimitRequired && lossLimit.values != null;
    }
}
